import { defineComponent as _defineComponent } from 'vue'
import { ref } from "vue";
import BaseModal from "@/components-UI/modals/BaseModal.vue";
import BaseButtonV2 from "@/components-UI/buttons/BaseButtonV2.vue";

interface Props {
    approveText?: string;
    rejectText?: string;
    maxWidth?: number
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseConfirmModal',
  props: {
    approveText: { default: 'Покинуть' },
    rejectText: { default: 'Остаться' },
    maxWidth: { default: 500 }
  },
  setup(__props: any, { expose }) {

const props = __props as { approveText: string, rejectText: string, maxWidth: number }



const isShowModal = ref(false);
const confirmMessage = ref('');
let resolvePromise: (value: PromiseLike<boolean> | boolean) => void;

const openModal = (message: string) => {
    confirmMessage.value = message;
    isShowModal.value = true;
    return new Promise((resolve) => {
        resolvePromise = resolve;
    });
};

const handleInput = (value: boolean) => {
    if (!resolvePromise) return;
    resolvePromise(value);
    isShowModal.value = false;
};

expose({
    openModal,
});

return { __sfc: true,props, isShowModal, confirmMessage, resolvePromise, openModal, handleInput, BaseModal, BaseButtonV2 }
}

})